module.exports = __webpack_public_path__ + "toBride1-we-p-w.89ebaf09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-p-w.jpg
// module id = 910o
// module chunks = 0